import { differenceInCalendarDays, differenceInHours, format } from "date-fns";

const DATETIME_FORMAT = "dd/MM/yyyy HH:mm";

export type API_TCase = {
  case_progress_step_belongs_to_role: string;
  case_progress_step_id: number;
  case_progress_step_index: string;
  case_progress_step_name: string;
  case_type: string;
  company_name: string;
  final_decision: string;
  first_name: string;
  has_child_case?: boolean;
  id: number;
  last_name: string;
  resubmission_date: string;
  submission_date: string;
  is_extension: boolean;
};

export type API_TCase_Filter = {
  case_progress_step_name: string[];
  case_type: string[];
  company_name: string[];
  final_decision: string[];
  applicant_name: TCase_Filter_Applicant_Name[];
  name: string[];
  is_extension: boolean[];
  has_child_case: boolean[];
};

export type TCase_Filter_Applicant_Name = {
  first_name: string;
  last_name: string;
  applicant_name: string;
};

export type TCase_Table = {
  [key: string]: string | number | boolean | undefined;
  id: number;
  case_type: string;
  company_name: string;
  applicant_name: string;
  submission_date: string;
  resubmission_date: string;
  time_elapsed: string;
  case_progress_step_name: string;
  final_decision: string;
  is_extension: boolean;
  has_child_case: boolean;
};

export const convertCasesForTable = (a: API_TCase): TCase_Table => {
  const formatStr = DATETIME_FORMAT;
  const currentDate = new Date();

  let submissionDate: any =
    a.submission_date && Date.parse(a.submission_date) > 0 ? new Date(a.submission_date) : null;

  const timeElapsed = submissionDate
    ? `${differenceInHours(currentDate, submissionDate)}h/${differenceInCalendarDays(
        currentDate,
        submissionDate
      )} days`
    : "―";

  submissionDate = submissionDate ? format(submissionDate, formatStr) : "―";

  let reSubmissionDate: any =
    a.resubmission_date && Date.parse(a.resubmission_date) > 0
      ? new Date(a.resubmission_date)
      : null;
  reSubmissionDate = reSubmissionDate ? format(reSubmissionDate, formatStr) : "―";

  return {
    id: a.id,
    case_type: a.case_type ? a.case_type : "—",
    company_name: a.company_name ? a.company_name : "―",
    applicant_name: a.first_name && a.last_name ? `${a.first_name} ${a.last_name}` : "―",
    name: a.first_name && a.last_name ? `${a.first_name} ${a.last_name}` : "―",
    submission_date: submissionDate,
    resubmission_date: reSubmissionDate,
    time_elapsed: timeElapsed,
    case_progress_step_name: a.case_progress_step_name ? a.case_progress_step_name : "―",
    final_decision: a.final_decision ? a.final_decision : "―",
    is_extension: a.is_extension,
    has_child_case: Boolean(a.has_child_case),
  };
};
